import { createContext, useContext } from 'react';

export const ClassInsightsContext = createContext(null);

export const useClassInsights = () => useContext(ClassInsightsContext);
